"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Grid_1 = tslib_1.__importStar(require("@sportnet/ui/lib/Grid"));
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Ladder_1 = tslib_1.__importDefault(require("./Ladder"));
var CustomRow = styled_components_1["default"](Grid_1.Row)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  justify-content: center;\n"], ["\n  justify-content: center;\n"])));
var C = function (_a) {
    var data = _a.data, renderEmpty = _a.renderEmpty;
    if ((!data.competitionId ||
        !data.partId ||
        !data.stats ||
        data.stats.length === 0) &&
        renderEmpty) {
        return React.createElement(React.Fragment, null, renderEmpty('playerStats'));
    }
    if (data.data) {
        var getStatsByStatName_1 = function (statName) {
            var results = data.data.players;
            var sorted = results.sort(function (a, b) {
                if (a.stats[statName] > b.stats[statName] ||
                    (a.stats[statName] === b.stats[statName] && a.name < b.name)) {
                    return -1;
                }
                else if (a.stats[statName] < b.stats[statName] ||
                    (a.stats[statName] === b.stats[statName] && a.name > b.name)) {
                    return 1;
                }
                return 0;
            });
            var limited = tslib_1.__spreadArrays(sorted).slice(0, 5)
                .filter(function (i) { return i.stats[statName] > 0; });
            return limited.map(function (i) {
                var team = data.data.teams.find(function (t) { return t._id === i.teamId; });
                return tslib_1.__assign(tslib_1.__assign({}, i), { team: team });
            });
        };
        return (React.createElement(CustomRow, null, (data.stats || []).map(function (_a, idx) {
            var label = _a.label, value = _a.value;
            var statResults = getStatsByStatName_1(value);
            if (statResults && statResults.length > 0) {
                return (React.createElement(Grid_1["default"], { xs: 12, s: 6, l: 3, key: value + "_" + idx },
                    React.createElement(Ladder_1["default"], { header: label, statName: value, items: statResults })));
            }
            return null;
        })));
    }
    return null;
};
exports["default"] = C;
var templateObject_1;
